import { render, staticRenderFns } from "./no-results-row.vue?vue&type=template&id=2d9dbbd6"
import script from "./no-results-row.vue?vue&type=script&lang=js"
export * from "./no-results-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports